import { render } from "./WorkPlace.vue?vue&type=template&id=1541bfdc"
import script from "./WorkPlace.vue?vue&type=script&lang=ts"
export * from "./WorkPlace.vue?vue&type=script&lang=ts"
script.render = render

export default script